"use client";

import { useEffect } from "react";

export function GlobalErrorHandler() {
	useEffect(() => {
		const handleEvent = (event: ErrorEvent | PromiseRejectionEvent) => {
			if (
				event instanceof PromiseRejectionEvent &&
				event.reason instanceof ProgressEvent
			) {
				event.preventDefault();
				return;
			}

			const message =
				event instanceof ErrorEvent
					? event.message
					: typeof event.reason === "object"
						? event.reason?.message
						: String(event.reason);

			const isThirdPartyError =
				message?.includes("gorgias") ||
				message?.includes("subscription") ||
				message?.includes("ProgressEvent") ||
				message?.includes("[object ProgressEvent]") ||
				message?.includes("9gtb") ||
				message?.includes("loader.js") ||
				(event instanceof ErrorEvent &&
					(event.filename?.includes("gorgias") ||
						event.filename?.includes("9gtb") ||
						event.filename?.includes("loader.js")));

			if (isThirdPartyError) {
				event.preventDefault();
				return;
			}
		};

		window.addEventListener("error", handleEvent);
		window.addEventListener("unhandledrejection", handleEvent);

		return () => {
			window.removeEventListener("error", handleEvent);
			window.removeEventListener("unhandledrejection", handleEvent);
		};
	}, []);

	return null;
}
